import React from "react";
import Portal from "./Portal";
/**
 * This is a very simple component that is used in other places within react-md
 * to conditionally render the children within a portal or not based on general
 * portal config props.
 */
export default function ConditionalPortal(_a) {
    var portal = _a.portal, portalInto = _a.portalInto, portalIntoId = _a.portalIntoId, children = _a.children;
    if (!portal && !portalInto && !portalIntoId) {
        return children;
    }
    return (React.createElement(Portal, { into: portalInto, intoId: portalIntoId }, children));
}
if (process.env.NODE_ENV !== "production") {
    try {
        var PropTypes = require("prop-types");
        ConditionalPortal.propTypes = {
            portal: PropTypes.bool,
            portalInto: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.func,
                PropTypes.object,
            ]),
            portalIntoId: PropTypes.string,
            children: PropTypes.node,
        };
    }
    catch (e) { }
}
//# sourceMappingURL=ConditionalPortal.js.map